import { SealCheck } from "@phosphor-icons/react";

/**
 * v3.2.41 · Small teal checkmark used across the app to signal that a
 * user's email is verified. Renders nothing when `verified` is falsy,
 * so callers can drop it in blindly next to any name.
 *
 *   <span>{name}<VerifiedBadge verified={u.email_verified} /></span>
 */
export default function VerifiedBadge({ verified, size = 14, className = "", title }) {
  if (!verified) return null;
  return (
    <span
      title={title || "Email verified"}
      className={`inline-flex items-center align-middle ml-1 ${className}`}
      data-testid="verified-badge"
    >
      <SealCheck size={size} weight="fill" className="text-[#00E5FF]" />
    </span>
  );
}
